import React, { useState, useEffect } from 'react'

// next components

// custom components
import OutlineButton from 'components/Button/OutlineButton'

// custom functions
import { useViewport } from 'utils'

// import images and icons

// styles
import styles from './index.module.scss'

const ProfileSearchBox = props => {
  const { onSearch } = props

  const [searchKeyword, setSearchKeyword] = useState('')
  const [timer, setTimer] = useState(null)

  useEffect(() => {
    if (searchKeyword !== '' && searchKeyword.length >= 2) {
      if (timer) {
        clearTimeout(timer)
        setTimer(null)
      }
      setTimer(
        setTimeout(() => {
          onSearch(searchKeyword)
        }, 500)
      )
    } else {
      if (focus && searchKeyword === '') onSearch('')
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchKeyword])

  const viewport = useViewport()
  const [focus, setFocus] = useState(false)

  const handleClose = () => {
    setSearchKeyword('')
    onSearch('')
  }

  return (
    <div className="w-full flex items-center">
      <div className={`${styles.container}`}>
        <div className={`${styles.searchArea}`}>
          <div className={styles.searchText}>
            {viewport === 'xs' || viewport === 'sm' || viewport === 'md' ? (
              <div className={styles.iconArea} onClick={() => handleClose()}>
                {searchKeyword !== '' ? (
                  <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} viewBox="0 0 8.635 8.634">
                    <path
                      id="times-7"
                      d="M11.326,10.312c0-1.542,3.091-3.084,3.091-3.084A.722.722,0,1,0,13.4,6.207L10.312,9.3,7.228,6.207A.722.722,0,1,0,6.207,7.228l2.508,2.5.583.582L6.207,13.4a.722.722,0,1,0,1.021,1.021l3.084-3.091L13.4,14.417A.722.722,0,1,0,14.417,13.4S11.326,11.854,11.326,10.312Z"
                      transform="translate(-5.994 -5.996)"
                      fill="var(--text-gray-200-color)"
                      opacity="0.6"
                    />
                  </svg>
                ) : (
                  <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} viewBox="0 0 22.017 22">
                    <path
                      id="search-32"
                      d="M23.687,22.124,19.6,18.076A9.9,9.9,0,1,0,18.076,19.6l4.049,4.049a1.093,1.093,0,1,0,1.562-1.529ZM11.9,19.6a7.7,7.7,0,1,1,7.7-7.7,7.7,7.7,0,0,1-7.7,7.7Z"
                      transform="translate(-1.979 -1.979)"
                      fill="var(--text-gray-200-color)"
                    />
                  </svg>
                )}
              </div>
            ) : (
              <div className={styles.iconArea} onClick={() => handleClose()}>
                <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} viewBox="0 0 22.017 22" opacity={1}>
                  <path
                    id="search-32"
                    d="M23.687,22.124,19.6,18.076A9.9,9.9,0,1,0,18.076,19.6l4.049,4.049a1.093,1.093,0,1,0,1.562-1.529ZM11.9,19.6a7.7,7.7,0,1,1,7.7-7.7,7.7,7.7,0,0,1-7.7,7.7Z"
                    transform="translate(-1.979 -1.979)"
                    fill="var(--text-gray-200-color)"
                  />
                </svg>
              </div>
            )}

            <input
              className={styles.inputArea}
              value={searchKeyword}
              placeholder={'Search'}
              onFocus={() => setFocus(true)}
              onChange={event => setSearchKeyword(event.target.value)}
            />
          </div>

          {viewport === 'xs' || viewport === 'sm' || viewport === 'md' ? (
            <div></div>
          ) : (
            <div>
              {searchKeyword.length > 0 && (
                <OutlineButton
                  label="Cancel"
                  onClick={() => {
                    handleClose()
                    setFocus(false)
                  }}
                  fontSize={16}
                  width={60}
                  color={'var(--bg-A5A5A5-606060);'}
                  backgroundColor="transparent"
                  borderColor="transparent"
                />
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default ProfileSearchBox
